module.exports = __webpack_public_path__ + "media/homepage/buzzfeed-logo-41f97af2.svg";